// extracted by mini-css-extract-plugin
module.exports = {"title_name":"Panel__title_name___3GiRO","title_count":"Panel__title_count___3mkLj"};